import type { ComponentProps } from 'react';
import React from 'react';
import type { ViewProps } from 'react-native';

import { BodyText } from '../Text';
import { getProductIngredientsList } from './ProductIngredientsList.utils';

// ────────────────────────────────────────────────────────────────────────────────

export const ProductIngredientsList = (props: ProductIngredientsListProps) => {
  const {
    addedIngredients = [],
    addedIngredientsLabel = 'Add:',
    addedIngredientsListTestID,
    removedIngredients = [],
    removedIngredientsLabel = 'Remove:',
    removedIngredientsListTestID,
    textSize,
  } = props;

  return (
    <>
      {addedIngredients.length > 0 ? (
        <IngredientsList
          ingredients={addedIngredients}
          label={addedIngredientsLabel}
          testID={addedIngredientsListTestID}
          textSize={textSize}
        />
      ) : null}

      {removedIngredients.length > 0 ? (
        <IngredientsList
          ingredients={removedIngredients}
          label={removedIngredientsLabel}
          testID={removedIngredientsListTestID}
          textSize={textSize}
        />
      ) : null}
    </>
  );
};

// ─── SUBCOMPONENTS ──────────────────────────────────────────────────────────────

const IngredientsList = (props: LineItemIngredientsListProps) => {
  const { ingredients = [], label, testID, textSize = 4 } = props;

  if (ingredients.length === 0) return null;

  const formattedIngredients = getProductIngredientsList(ingredients);

  return (
    <BodyText size={textSize} testID={testID}>
      {label} {formattedIngredients}
    </BodyText>
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ProductIngredientsListProps = Readonly<{
  addedIngredients?: Ingredients;
  addedIngredientsLabel?: string;
  addedIngredientsListTestID?: ViewProps['testID'];
  removedIngredients?: Ingredients;
  removedIngredientsLabel?: string;
  removedIngredientsListTestID?: ViewProps['testID'];
  textSize?: LineItemIngredientsListProps['textSize'];
}>;

type LineItemIngredientsListProps = Readonly<{
  label: string;
  ingredients: Ingredients;
  testID?: ViewProps['testID'];
  textSize?: ComponentProps<typeof BodyText>['size'];
}>;

type Ingredients = ReadonlyArray<
  Readonly<{
    name?: string;
  }>
>;
